import { library } from '@fortawesome/fontawesome-svg-core';
// import { fab } from '@fortawesome/free-brands-svg-icons';
import { faEye, faEyeSlash, faSearch, faSignOutAlt, faPen, faGift, faTrash, faTrashAlt, faCaretUp, faCaretDown, faAngleLeft } from '@fortawesome/free-solid-svg-icons';

library.add(faEye, faEyeSlash, faSearch, faSignOutAlt, faPen, faTrash, faTrashAlt, faCaretUp, faCaretDown, faGift, faAngleLeft)